import VModel from '@/app-core/mixins/vModel'
import {formatUnitQuantity} from '@/app-core/lib/utils/currency/currency'

export default {
  name      : 'ProductDialogQuantitySelector',
  components: {},
  directives: {},
  mixins    : [VModel],
  props     : {
    min: {
      type   : [Number, String],
      default: 1
    },

    max: {
      type   : [Number, String],
      default: undefined
    },

    step: {
      type   : [Number, String],
      default: 1
    },

    unitId: {
      type   : Number,
      default: 1
    },

    quantityAnimation: {
      type   : Boolean,
      default: false
    },

    flyAnimation: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {}
  },
  computed: {
    quantity() {
      return this.unitId > 1 ? formatUnitQuantity(this.$i18n.locale, this.vModel, this.getMeasurementUnitById(this.unitId)) : this.vModel
    },
    quantityAnim() {
      return this.unitId > 1 ? formatUnitQuantity(this.$i18n.locale, this.vModel, this.getMeasurementUnitById(this.unitId), false) : this.vModel
    }
  },
  watch: {
    min: {
      immediate: true,
      handler(newVal) {
        if (newVal > this.vModel) this.vModel = newVal
      }
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    formatUnitQuantity,
    onDecrementClick() {
      if (this.vModel > parseInt(this.min)) this.vModel -= parseInt(this.step || 1)
      this.triggerQuantityAnimation()
      this.triggerFlyAnimation()
    },

    onIncrementClick() {
      if (!this.max || this.vModel < parseInt(this.max)) this.vModel += parseInt(this.step || 1)
      this.triggerQuantityAnimation()
      this.triggerFlyAnimation()
    },

    triggerFlyAnimation() {
      if (!this.flyAnimation) return

      const el = this.$refs.fly?.$el
      if (!el) return

      el.style.animation = 'none'

      el.offsetHeight /* trigger reflow */
      el.style.animation = null
      el.classList.add('quantityFlyAnimation')
    },

    triggerQuantityAnimation() {
      if (!this.quantityAnimation) return

      const el = this.$refs.quantity
      if (!el) return

      el.style.animation = 'none'

      el.offsetHeight /* trigger reflow */
      el.style.animation = null
      el.classList.add('quantityTextAnimation')
    },

    getMeasurementUnitById(id) {
      if (!id) return null

      return this.$t('Common.Units')?.find(item => item.Id === id) || null
    }
  }
}
